import { Component, Input } from '@angular/core';

export interface IRaptorBannerData {
  content?: any
  icon?: {
    name?: string,
    size?: string
  };
}
@Component({
  selector: 'open-raptor-banner-header',
  templateUrl: './raptor-banner-header.component.html',
  styleUrls: ['./raptor-banner-header.component.scss']
})
export class RaptorBannerHeaderComponent {
  @Input() data!: Array<IRaptorBannerData>;
}
